import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { Box, styled, Switch, InputAdornment } from "@mui/material";
import { useEffect } from "react";

const EditableTextInput = ({
  inputId,
  propsInitialValue,
  editMode,
  inputMode,
  adornment,
  setParentValue,
}) => {
  const [value, setValue] = useState(
    propsInitialValue !== null ? propsInitialValue : ""
  );
  const [initialValue, setInitialValue] = useState(
    propsInitialValue !== null ? propsInitialValue : ""
  );
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");

  // has been focused in edit mode
  const [touched, setTouched] = useState(false);

  // callback from the parent
  const handleInputChange = (e) => {
    setValue(e.target.value);
  };

  const handleBlur = () => {
    if (inputId === "email") {
      const trimmed = value.trim();
      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
      if (!isValidEmail) {
        setError(true);
        setHelperText("Inserisci un indirizzo mail valido");
        return;
      }
      setError(false);
      setHelperText("");
      if (trimmed !== value) {
        setValue(trimmed);
      }
    }

    if (value !== initialValue) {
      setTouched(true);
      setParentValue(inputId, value);
    }
  };

  return (
    <Grid container alignItems="center" spacing={1}>
      <Grid item xs>
        <TextField
          variant={inputMode === "text" ? "standard" : "outlined"}
          value={value}
          size="small"
          fullWidth
          onChange={handleInputChange}
          onBlur={handleBlur}
          type={inputId === "email" ? "email" : "text"}
          error={error}
          helperText={helperText}
          sx={{
            "& .MuiInputBase-input": {
              padding: inputMode === "text" ? 0 : "auto",
            },
          }}
          InputProps={{
            disableUnderline: !editMode,
            readOnly: !editMode,
            startAdornment: (
              <InputAdornment position="start">{adornment}</InputAdornment>
            ),
          }}
          inputMode={inputMode}
        />
      </Grid>
    </Grid>
  );
};

export default EditableTextInput;
